// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__HGUz-","empty":"ModalGraph_empty__11FMI"};